/* tslint:disable */
/* eslint-disable */
/**
 * Example API
 * API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetChatHistory200ResponseInnerPartsInner } from './GetChatHistory200ResponseInnerPartsInner';
import {
    GetChatHistory200ResponseInnerPartsInnerFromJSON,
    GetChatHistory200ResponseInnerPartsInnerFromJSONTyped,
    GetChatHistory200ResponseInnerPartsInnerToJSON,
    GetChatHistory200ResponseInnerPartsInnerToJSONTyped,
} from './GetChatHistory200ResponseInnerPartsInner';

/**
 * 
 * @export
 * @interface GetChatHistory200ResponseInner
 */
export interface GetChatHistory200ResponseInner {
    /**
     * Unique identifier for the message, composed of threadId and message index
     * @type {string}
     * @memberof GetChatHistory200ResponseInner
     */
    id?: string;
    /**
     * Timestamp when the message was created
     * @type {Date}
     * @memberof GetChatHistory200ResponseInner
     */
    createdAt?: Date;
    /**
     * Text content of the message
     * @type {string}
     * @memberof GetChatHistory200ResponseInner
     */
    content?: string;
    /**
     * Role of the message sender
     * @type {string}
     * @memberof GetChatHistory200ResponseInner
     */
    role?: GetChatHistory200ResponseInnerRoleEnum;
    /**
     * Message parts for UI rendering
     * @type {Array<GetChatHistory200ResponseInnerPartsInner>}
     * @memberof GetChatHistory200ResponseInner
     */
    parts?: Array<GetChatHistory200ResponseInnerPartsInner>;
}


/**
 * @export
 */
export const GetChatHistory200ResponseInnerRoleEnum = {
    User: 'user',
    Assistant: 'assistant'
} as const;
export type GetChatHistory200ResponseInnerRoleEnum = typeof GetChatHistory200ResponseInnerRoleEnum[keyof typeof GetChatHistory200ResponseInnerRoleEnum];


/**
 * Check if a given object implements the GetChatHistory200ResponseInner interface.
 */
export function instanceOfGetChatHistory200ResponseInner(value: object): value is GetChatHistory200ResponseInner {
    return true;
}

export function GetChatHistory200ResponseInnerFromJSON(json: any): GetChatHistory200ResponseInner {
    return GetChatHistory200ResponseInnerFromJSONTyped(json, false);
}

export function GetChatHistory200ResponseInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetChatHistory200ResponseInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'content': json['content'] == null ? undefined : json['content'],
        'role': json['role'] == null ? undefined : json['role'],
        'parts': json['parts'] == null ? undefined : ((json['parts'] as Array<any>).map(GetChatHistory200ResponseInnerPartsInnerFromJSON)),
    };
}

  export function GetChatHistory200ResponseInnerToJSON(json: any): GetChatHistory200ResponseInner {
      return GetChatHistory200ResponseInnerToJSONTyped(json, false);
  }

  export function GetChatHistory200ResponseInnerToJSONTyped(value?: GetChatHistory200ResponseInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'content': value['content'],
        'role': value['role'],
        'parts': value['parts'] == null ? undefined : ((value['parts'] as Array<any>).map(GetChatHistory200ResponseInnerPartsInnerToJSON)),
    };
}

